export default {
  getUserInitials: (fn, ln) => {
    if (fn !== undefined && ln !== undefined) {
      return fn.substring(0, 1) + ln.substring(0, 1);
    }
    return null;
  },
};
